var React = require('react');

function ArrowLinkAngled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3L6.42322 4.49429L10.5057 8.57678L12 3ZM3.35355 12.3536L9.17157 6.53553L8.46447 5.82843L2.64645 11.6464L3.35355 12.3536Z","fill":"black"}));
}

ArrowLinkAngled.defaultProps = {"viewBox":"0 0 15 15","fill":"none"};

module.exports = ArrowLinkAngled;

ArrowLinkAngled.default = ArrowLinkAngled;
